// Dev-only escape hatch for the landing page redesign: lets a system admin
// fall back to the pre-redesign LandingPageLegacy.jsx on their own browser
// (via Dev Tools) without a deploy or affecting any other visitor. Deliberately
// a plain localStorage flag rather than a Firestore/remote-config flag — this
// is a personal, per-browser override, not a real feature flag for real users.
const KEY = 'quotehaul_landing_theme_version';

export function getLandingThemeVersion() {
  try {
    return localStorage.getItem(KEY) === 'legacy' ? 'legacy' : 'new';
  } catch (e) {
    return 'new';
  }
}

export function setLandingThemeVersion(version) {
  try {
    if (version === 'legacy') {
      localStorage.setItem(KEY, 'legacy');
    } else {
      localStorage.removeItem(KEY);
    }
  } catch (e) {}
}
